import { meetApi } from "../cnb/apis";
import { Meeting } from "../lib/cnb/api/public";

const api = {
  getAllMeetings: async (workspaceId: string): Promise<Meeting[]> =>
    meetApi.getAllMeetings({ workspaceId }),
};

export default api;
